const environment = process.env.REACT_APP_ENV as "local" | "stage" | "prod";
const host = "10.10.7.121";
const environments = {
  local: {
    serverURL: "http://localhost:8080",
  },
  local2: {
    serverURL: `http://${host}:8080`,
  },
  stage: {
    serverURL: "https://vdfnloqpnk.execute-api.ap-south-1.amazonaws.com",
  },
  prod: {
    serverURL: "http://localhost:8080",
  },
};

export const ENV_CONFIG = environments[environment] || environments.local;
